var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"login-menu-button",class:{ 'logged-in': _setup.isLoggedIn },attrs:{"disabled":_setup.loading},on:{"click":_setup.handleLoginClick}},[_c('FontAwesomeIcon',{attrs:{"icon":_setup.faUserCog}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }